import { CheckboxProps, Checkbox as MuiCheckbox } from '@mui/material';
import { ReactComponent as UnCheckedIcon } from './uncheck.svg';
import { ReactComponent as CheckedIcon } from './check.svg';
import { JSX } from 'react/jsx-runtime';
import { theme } from '@src/theme';
import { useMemo } from 'react';

export const Checkbox = ({ error, ...props }: JSX.IntrinsicAttributes & CheckboxProps & { error?: boolean }) => {
  const color = useMemo(() => {
    if (props.disabled) return theme.palette.grey['300'];
    if (error) return theme.palette.error['200'];
    return theme.palette.secondary.main;
  }, [error, props.disabled]);

  return (
    <MuiCheckbox
      icon={<UnCheckedIcon />}
      sx={{ '& svg rect': { stroke: color } }}
      checkedIcon={<CheckedIcon />}
      {...props}
    />
  );
};
